import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {QueryParams} from "../../../../model/interfaces/request";
import {HttpControllers} from "../../../../utils/Class/HttpController";
import {DATA_SOURCE} from "../../../../../environments/environment";
import {FilterProductosPerforDTO} from "../../models/diccionarioTvcInterface";

@Injectable({
  providedIn: 'root'
})
export class MantenedorProductoLogsService {

  tvcModulo: any = {};
  urlIndustrias: any = {};
  url: string;

  constructor(
    private _util: UtilsService,
    private _commom: CommonService,
    private http: HttpClient
  ) {
    this.tvcModulo = moduloPerform;
    this.urlIndustrias = this.tvcModulo.url.productologs;
    this.url = this._util.getUrlIoIndustrias();
  }

  getAllOrdenProductos() {
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base);
  }

  crearProductoSpecs(innObjPlc: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlIndustrias.base, innObjPlc);
  }

  actualizarProductoSpecs(innObjPlc: any) {
    return this._commom.peticionPutConHeader(this.url + this.urlIndustrias.base, innObjPlc);
  }

  enviarPlcProductoSpecs(innObjPlc: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlIndustrias.base+'/send', innObjPlc);
  }

  buscarProductoSpecs(idMaterial:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/${idMaterial}`);
  }

  buscarbyIdLinea(idLinea:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/linea/${idLinea}`);
  }

  deleteRegistro(idRegistro: string) {
    return this._commom.peticionDeleteConHeader(this.url + this.urlIndustrias.base + `/${idRegistro}`);
  }

  buscarbyIdLineaQuery(queryParams: QueryParams<FilterProductosPerforDTO>)  {
    return new HttpControllers(this.http)
      .read({
        datasource: DATA_SOURCE.IO_INDUSTRIAS,
        path: 'producto-logs/search',
        queryParams: queryParams
      });
  }


}
